import api from "../services/api";
import Cookies from "js-cookie";
import { stringToDate } from "../hooks/utils/useFormat";

export default async function getCalendar(commercial_id) {
  let _token = Cookies.get("user-token");
  _token = _token ? JSON.parse(_token) : null;
  const config = {
    headers: { Authorization: `Bearer ${_token?.token}` },
  };

  if (commercial_id) {
    const _calendar_raw = await api.get(`/calendars?commercial_id=${commercial_id}&active=1`, config);

    return _calendar_raw.data.map(__task => ({
      id: __task.id,
      name: __task.title,
      active: __task.active,
      all_day: __task.all_day,
      date_start: __task.date_start,
      date_end: __task.all_day ? __task.date_start : __task.date_end,
      description: __task.description,
      done: __task.done,
      active: __task.active,
      status: __task.done
        ? "Concluída"
        : new Date() > stringToDate(__task.date_end) && !__task.all_day
          ? "Atrasada"
          : __task.status === "foreseen"
            ? "Prevista"
            : __task.status === "confirmed"
              ? "Confirmada"
              : __task.status === "pending"
                ? "Pendente"
                : null,
      user: {
        id: __task.user?.id,
        name: __task.user?.username,
      },
    }));
  }
}
